module.exports = __webpack_public_path__ + "static/section5-74126ade84ae5ab3524c188dff073618.svg";